import type {
    AdminNavEntryGroup,
    AdminNavEntryItem,
    AdminSidebarItem,
} from '@/layouts/sidebar/config';

const isGroup = (entry: AdminSidebarItem): entry is AdminNavEntryGroup =>
    typeof (entry as AdminNavEntryGroup).entries !== 'undefined';

/**
 * Drops entries whose path is switched off for this lift operator. Unlike
 * `disabledPaths` (which only greys the label out) the entry disappears
 * entirely, so a feature the operator has not booked is not advertised.
 * Paths are compared without their query string, because some entries carry
 * parameters (the widget editor passes the lift operator in the URL).
 *
 * Kept free of runtime imports from `@starjack/layout` so it can be unit
 * tested without the layout package build.
 */
export function stripHiddenPaths(
    entries: AdminSidebarItem[],
    hiddenPaths: string[]
): AdminSidebarItem[] {
    if (!hiddenPaths.length) return entries;
    const isHidden = (path: string) => hiddenPaths.includes(path.split('?')[0]);
    return entries.reduce<AdminSidebarItem[]>((acc, entry) => {
        if (isGroup(entry)) {
            const kept = entry.entries.filter((item) => !isHidden(item.path));
            if (kept.length) acc.push({ ...entry, entries: kept });
        } else {
            const item = entry as AdminNavEntryItem;
            if (!isHidden(item.path)) acc.push(item);
        }
        return acc;
    }, []);
}
